import { compose } from 'recompose';
import {
  set,
  lensPath,
  curry,
  join,
  cond,
  always,
  toUpper,
  equals,
  T
} from 'ramda';
import { APP_ROOT } from 'src/route_constants';
import {
  ID,
  NAME,
  SUBJECT,
  SMS_SUBJECT,
  TEMPLATE_NAME,
  CALL_TO_ACTION,
  EMPTY_OBJECT,
  DOT,
  TEMPLATE_EXTN_HBS,
  MORTGAGE_LOAN_TEXT,
  SMALL_BUSINESS_LOAN_TEXT,
  BUSINESS_FUNDING_LOAN_TEXT
} from 'src/utilities/notifications/constants';
import {
  RESIDENTIAL_MORTGAGE,
  MERCHANTCASHADVANCES,
  SMALL_BUSINESS
} from 'src/features/LoansHome/Products/constants';
import { doNothing } from 'src/services/constants';

/**
 * build notification config
 */

export const template_config = (
  id: any,
  type: any,
  subject: any,
  sms_subject: any,
  static_url: any,
  template: any
) => {
  return compose(
    set(lensPath([ID]), id),
    set(lensPath([NAME]), type),
    set(lensPath([SUBJECT]), subject),
    set(lensPath([SMS_SUBJECT]), sms_subject),
    set(lensPath([TEMPLATE_NAME]), notificationTemplateName(template)),
    set(lensPath([CALL_TO_ACTION]), buildCallToActionURL(static_url))
  )(EMPTY_OBJECT);
};

/**
 * build template name
 * ex: 0001_signup.hbs - this is for signup
 */
const notificationTemplateName = (template: any) => {
  return join('', [template, DOT, TEMPLATE_EXTN_HBS]);
};

/**
 * build the url and send it.
 */
export const buildCallToActionURL = (actionUrl: any) => {
  const endsWith = curry((q, str) => str.endsWith(q));
  const stripr = curry((q, str) =>
    endsWith(q, str) ? str.slice(0, str.length - q.length) : str
  );
  return join('', [stripr('/', APP_ROOT), actionUrl]);
};

/**
 * when need to add new notification config then following steps
 * first construct template config using below template
 * export const name_template_config = (options: any) => {
 *  const email_subject = <subject>;
 *  const sms_subject = <subject>
 *  return template_config(
 *    '0008',
 *    TASK_CREATED_CONFIG,
 *    email_subject,
 *    sms_subject,
 *    TASK_STATIC_URL,
 *    TASK_CREATED_TEMPLATE
 *  );
 *}
 * the above const returns your notification config
 * then add this const to siteNotifications list
 * now new notification is added to sitenotifications list
 */

export const proceedToFillingSubject = (loanType: string) => {
  if (loanType) {
    return cond([
      [equals(RESIDENTIAL_MORTGAGE), always(MORTGAGE_LOAN_TEXT)],
      [equals(SMALL_BUSINESS), always(SMALL_BUSINESS_LOAN_TEXT)],
      [equals(MERCHANTCASHADVANCES), always(BUSINESS_FUNDING_LOAN_TEXT)],
      [T, always(doNothing)]
    ])(toUpper(loanType));
  }
};
